// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from './types.tsx';

export const setDeferredNavigationLink =
	(deferredNavigationLink: string): Action<State> =>
	({ setState }) =>
		setState({ deferredNavigationLink });

export const actions = { setDeferredNavigationLink } as const;
